export default __webpack_public_path__ + "static/media/img-stacking-3-value.03ff3723.png";